// extracted by mini-css-extract-plugin
export default {"cls1":"SmallAccountMenuButton-cls1__qd","cls2":"SmallAccountMenuButton-cls2_KkW SmallAccountMenuButton-cls1__qd"};